import HomeView from '@/views/HomeView.vue'
import ScanView from '@/views/ScanView.vue'
import ProductDetailView from '@/views/ProductDetailView.vue'
import RegisterScanView from '@/views/RegisterScanView.vue'
import RegisterSelectView from '@/views/RegisterSelectView.vue'
import RegisterSuccessView from '@/views/RegisterSuccessView.vue'

import { useUiStore } from '@/stores/ui'
import { createRouter, createWebHistory } from 'vue-router'

const routes = [
    {
        path: '/',
        name: 'home',
        component: HomeView,
    },
    {
        path: '/product_info',
        name: 'product-info',
        component: ProductDetailView,
    },
    {
        path: '/scan',
        name: 'scan',
        component: ScanView,
    },
    {
        path: '/register',
        name: 'register-scan',
        component: RegisterScanView,
    },
    {
        path: '/register/select',
        name: 'register-select',
        component: RegisterSelectView,
    },
    {
        path: '/register/success',
        name: 'register-success',
        component: RegisterSuccessView,
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        return { top: 0, left: 0 }
    },
})

router.beforeEach((_to, _from, next) => {
    const ui = useUiStore()
    ui.startRouteLoading()
    next()
})

router.afterEach(() => {
    const ui = useUiStore()
    setTimeout(() => ui.stopRouteLoading(), 800)
})

export default router
